



































































































































































import Vue from 'vue';
import Component from 'vue-class-component';
import {
	mapActions, mapGetters, mapMutations, mapState,
} from 'vuex';
import AdditionalFieldsForm from '@/components/AdditionalFieldsForm.vue';
import ErrorList from '@/components/ErrorList.vue';
import LocationSelector from '@/components/LocationSelector.vue';
import MarkdownText from '@/components/ui/MarkdownText.vue';
import PersonalForm from '@/components/PersonalForm.vue';
import PaymentMethods from '@/components/PaymentMethods.vue';
import RecurringSignUp from '@/components/RecurringSignUp.vue';
import TermsAgreement from '@/components/TermsAgreement.vue';
import FormError from '@/components/ui/FormError.vue';
import VehiclesForm from '@/components/VehiclesForm.vue';
import MetaFieldsForm from '@/components/MetaFieldsForm.vue';
import FormMixin from '@/mixins/formMixin';
import Customer from '@/models/Customer';
import Vehicle from '@/models/Vehicle';
import { getOrArray, getOrFalse, has } from '@/utilities/helpers';
import RegistrationType from '@/models/RegistrationType';
import moment from 'moment';

const Setup = Vue.extend({
	name: 'TheRegisterPage',
	inject: ['$validator'],
	components: {
		AdditionalFieldsForm,
		ErrorList,
		FormError,
		LocationSelector,
		MarkdownText,
		PersonalForm,
		PaymentMethods,
		RecurringSignUp,
		TermsAgreement,
		VehiclesForm,
		MetaFieldsForm,
	},
	mixins: [FormMixin],
	props: {
		type: String,
		promo_code: Array,
	},
	watch: {
		location() {
			this.$nextTick(() => {
				(this as any).recaptchaActivate();
			});
		},
	},
	computed: {
		...mapState(['generalErrors', 'loggedInCustomer', 'paths', 'settings']),
		...mapState('location', ['locations']),
		...mapGetters(['corporationName']),
		...mapGetters('location', ['corporateCompany', 'corporatePromo', 'customerLocations', 'hasLocation', 'location', 'recurringLocations']),
		...mapGetters('reservation', { reservationCustomer: 'customer' }),
	},
	methods: {
		...mapMutations(['addError', 'clearErrors']),
		...mapMutations('location', ['clearLocation']),
		...mapActions('location', ['setLocation']),
		...mapActions('analytics', ['registerCustomer']),
	},
});

@Component
export default class TheRegisterPage extends Setup {
	public captcha_token: string|null = null;
	public type!: string;

	public customer = new Customer();
	public hasTos = false;
	public loading = false;
	public showAgreement = false;
	public tokenize = false;
	public tosAgreement = false;
	public count = 0;

	// Vuex
	public generalErrors!: any[];
	public paths!: { [propName: string]: string };
	public corporateCompany!: any;
	public customerLocations!: Locations.Location[];
	public hasLocation!: boolean;
	public location!: Locations.Location;
	public recurringLocations!: Locations.Location[];
	public clearLocation!: () => void;
	public setLocation!: (locationCode: string) => Promise<any>;

	public register!: (
		payload: { customer: Customer; location: string; reservation?: string; type: string },
	) => Promise<any>;

	public reservationCustomer!: Customer;

	public registerCustomer!: () => Promise<any>;

	public get airlines(): any[] {
		return getOrArray('settings.airline', this.location);
	}

	public get hasAch() {
		return this.customer.ach_accounts.length > 0
			&& has('ach_accounts.0.token', this.customer);
	}

	public get hasCard(): boolean {
		return this.customer.credit_cards.length > 0 && has('credit_cards.0.token', this.customer);
	}

	public get hasNewsletters(): boolean {
		return getOrFalse('settings.mailchimp_newsletter_audience', this.location);
	}

	public get hasPaymentMethod(): boolean {
		return this.hasCard || this.hasAch;
	}

	public get recaptcha_key(): string|boolean {
		if (!this.location.settings.disable_hosted_cc_forms && (this.registrationType.isRequired('credit_card') || this.registrationType.isRequired('recurring_sign_up') || this.loggedInCustomer.customer > 0 || this.registrationType.isCollected('credit_card') || this.registrationType.isCollected('recurring_sign_up'))) {
			return false;
		}
		return getOrFalse('settings.recaptcha_site_key', this.location);
	}

	public get registrationType(): ReturnType<typeof RegistrationType> {
		if (this.loggedInCustomer.customer > 0) {
			return RegistrationType();
		}

		if (this.registrationTypes.length === 1) {
			return RegistrationType(this.registrationTypes[0]);
		}

		return RegistrationType(
			this.registrationTypes.find((type) => type.name.toLowerCase() === this.type.toLowerCase())
			|| this.registrationTypes.find((type) => type.is_default),
		);
	}

	public get registrationTypes(): Locations.RegistrationType[] {
		return this.$store.getters['location/registrationTypes'];
	}

	public created() {
		if (this.$store.state.reservation.reservation.reservation) {
			this.customer = new Customer({ ...this.reservationCustomer });
		}

		this.customer.email_receipt = true;
		this.customer.newsletter_opt_in = true;

		if (this.customer.vehicles.length === 0) {
			this.customer.vehicles.push(new Vehicle());
		}

		if ((window as any).activeLocation) {
			this.setLocation((window as any).activeLocation as string);
		} else if (this.customerLocations.length === 1) {
			this.setLocation(this.customerLocations[0].codeID);
		}

		if (this.loggedInCustomer.company_obj.company > 0) {
			this.customer.company = this.loggedInCustomer.company_obj.company;
			this.customer.company_name = this.loggedInCustomer.company_obj.name;
			this.customer.company_obj = this.loggedInCustomer.company_obj;
		}
	}

	public mounted() {
		const current_date = moment().format('YYYY-MM-D LTS');
		if (this.settings && this.settings.corporation) {
			this.settings.corporation.promo_locations.forEach((promo_code_breakdown: any) => {
				if (promo_code_breakdown.promo_code) {
					this.promo_code.forEach((code_check: any) => {
						if (code_check.promo_code === promo_code_breakdown.promo_code) {
							if (code_check.active === false || code_check.promo_end < current_date) {
								window.location.replace(this.paths.home);
							}
						}
					});
				}
			});
		}

		if (this.location.settings.disable_hosted_cc_forms || (!this.location.settings.disable_hosted_cc_forms && !(this.registrationType.isRequired('credit_card') || this.registrationType.isRequired('recurring_sign_up') || this.loggedInCustomer.customer > 0 || this.registrationType.isCollected('credit_card') || this.registrationType.isCollected('recurring_sign_up')))) {
			this.recaptchaActivate();
		}
	}

	public recaptchaActivate() {
		if (this.location.settings.disable_hosted_cc_forms || (!this.location.settings.disable_hosted_cc_forms && !(this.registrationType.isRequired('credit_card') || this.registrationType.isRequired('recurring_sign_up') || this.loggedInCustomer.customer > 0 || this.registrationType.isCollected('credit_card') || this.registrationType.isCollected('recurring_sign_up')))) {
			try {
				(window as any).grecaptcha.render('g-recaptcha');
			} catch (error) {
				// Ignore captcha exceptions (likely due to ad-blocker)
			}
			(window as any).captcha_submit = (captcha_token: string) => { this.captcha_token = captcha_token }
			(window as any).captcha_error = () => { this.captcha_token = null }

			const urlSearchParams = new URLSearchParams(window.location.search);
			const params = Object.fromEntries(urlSearchParams.entries());
			let registration_count = 0;
			this.registrationTypes.forEach((element: any) => {
				if (element.name === params.type) {
					this.count = registration_count;
				}
				registration_count += 1;
			});
		}
	}

	public recaptchaReset() {
		if (!this.recaptcha_key && (this.location.settings.disable_hosted_cc_forms || (!this.location.settings.disable_hosted_cc_forms && !(this.registrationType.isRequired('credit_card') || this.registrationType.isRequired('recurring_sign_up') || this.loggedInCustomer.customer > 0 || this.registrationType.isCollected('credit_card') || this.registrationType.isCollected('recurring_sign_up'))))) {
			return;
		}

		(window as any).grecaptcha.reset();
		this.captcha_token = null;
	}

	public onSubmit() {
		if (this.recaptcha_key && !this.captcha_token && (this.location.settings.disable_hosted_cc_forms || (!this.location.settings.disable_hosted_cc_forms && !(this.registrationType.isRequired('credit_card') || this.registrationType.isRequired('recurring_sign_up') || this.loggedInCustomer.customer > 0 || this.registrationType.isCollected('credit_card') || this.registrationType.isCollected('recurring_sign_up'))))) {
			this.addError('Please complete the captcha.');
			return;
		}

		const has_ach = this.customer.ach_accounts.length > 0;
		const has_cc = this.customer.credit_cards.length > 0;

		if (this.$refs.payment && this.customer.paymentMethod !== 'group_company' && !has_ach && !has_cc) {
			this.tokenize = true;
		} else {
			this.validate();
		}
	}

	public setAch(account: any) {
		this.tokenize = false;

		if (account.token) {
			this.customer.ach_accounts.push({ ...account });
		}

		this.validate();
	}

	public setCreditCard(card: any) {
		this.tokenize = false;

		if (card.errors && (this.location.settings.disable_hosted_cc_forms || (!this.location.settings.disable_hosted_cc_forms && !(this.registrationType.isRequired('credit_card') || this.registrationType.isRequired('recurring_sign_up') || this.loggedInCustomer.customer > 0 || this.registrationType.isCollected('credit_card') || this.registrationType.isCollected('recurring_sign_up'))))) {
			this.recaptchaReset();
			return;
		}

		if (card.token) {
			this.customer.credit_cards = [{
				...card,
				new: true,
				primary: true,
			}];
		}

		this.validate();
	}

	public async validateEmail() {
		this.clearErrors();
		try {
			const data = await this.customer.validateEmail();
		} catch (error) {
			let errors = getOrArray('data.errors', error);
			if (!errors || !errors.length) {
				errors = getOrArray('errors', error);
			}

			errors.forEach(({ name, text }: any) => {
				if (name && text) {
					this.errors.add({ field: name, msg: text });
				} else {
					this.addError(text);
				}
			});

			this.$nextTick(() => {
				const element = this.$el.querySelector('.np-form-error:not([style*="display: none"]');
				if (element) {
					element.scrollIntoView({
						behavior: 'smooth',
						block: 'center',
					});
				}
			});

			this.loading = false;
		}
	}

	public async submit(agree: boolean) {
		if (!agree || this.errors.any()) {
			return;
		}

		this.loading = true;
		this.clearErrors();

		try {
			this.customer.code_id = this.location.codeID;
			this.customer.registration_type = this.registrationType.settings.name;
			if (this.location.settings.disable_hosted_cc_forms || (!this.location.settings.disable_hosted_cc_forms && !(this.registrationType.isRequired('credit_card') || this.registrationType.isRequired('recurring_sign_up') || this.loggedInCustomer.customer > 0 || this.registrationType.isCollected('credit_card') || this.registrationType.isCollected('recurring_sign_up')))) {
				this.customer.captcha_token = this.captcha_token;
			}

			const data = await this.customer.save();

			// Run the analytics action
			try {
				this.registerCustomer();
			} catch (error) {
				// Ignore analytics exceptions (likely due to ad-blocker)
			}
			this.$store.dispatch('googleEvents/signupSuccess', {});
			window.location.replace(data.redirect || this.paths.profile);
		} catch (error) {
			let errors = getOrArray('data.errors', error);
			if (!errors || !errors.length) {
				errors = getOrArray('errors', error);
			}

			errors.forEach(({ name, text }: any) => {
				if (name && text) {
					this.errors.add({ field: name, msg: text });
				} else {
					this.addError(text);
				}
			});
			this.$store.dispatch('googleEvents/signupFailed', {
				error: errors,
			});
			this.$nextTick(() => {
				const element = this.$el.querySelector('.np-form-error:not([style*="display: none"]');
				if (element) {
					element.scrollIntoView({
						behavior: 'smooth',
						block: 'center',
					});
				}
			});

			this.loading = false;
			if (this.location.settings.disable_hosted_cc_forms || (!this.location.settings.disable_hosted_cc_forms && !(this.registrationType.isRequired('credit_card') || this.registrationType.isRequired('recurring_sign_up') || this.loggedInCustomer.customer > 0 || this.registrationType.isCollected('credit_card') || this.registrationType.isCollected('recurring_sign_up')))) {
				this.recaptchaReset();
			}
		}
	}

	public async validate() {
		this.errors.clear();

		if (!await this.$validator.validateAll()) {
			this.$el.scrollIntoView({ behavior: 'smooth', block: 'start' });
			return;
		}

		this.tokenize = false;
		if ((this.registrationType.isCollected('recurring_sign_up')
				|| this.registrationType.isRequired('credit_card'))
			&& !this.hasPaymentMethod
		) {
			this.errors.add({
				field: 'paymentMethod',
				msg: 'A valid payment method is required.',
			});
		}

		if (this.location.settings.recurring_force_on_login && !this.customer.recurringOption) {
			this.errors.add({
				field: 'recurring',
				msg: 'You must select a recurring location.',
			});
		}

		if (this.errors.any()) {
			return;
		}

		if (this.hasTos) {
			this.showAgreement = true;
		} else {
			this.submit(true);
		}
	}
}
